import FadeInSection from './FadeInSection';

const SpokenLanguagesSection = () => {
    const languages = [
        { name: "Portuguese", level: "Native" },
        { name: "English", level: "Fluent" },
        { name: "French", level: "Fluent" },
        { name: "Spanish", level: "Intermediate" }
    ];

    return (
        <section id="languages" className="py-20">
            <FadeInSection>
                <h2 className="text-4xl font-orbitron font-bold text-center mb-12 text-glow">07. Channels</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-4xl mx-auto">
                    {languages.map((lang, index) => (
                        <div key={index} className="card-glow rounded-lg p-6 text-center hover:bg-[var(--primary-color)]/10 transition-colors duration-300">
                            <h3 className="text-xl font-orbitron text-[var(--primary-color)] mb-2">{lang.name}</h3>
                            <p className="text-gray-300">{lang.level}</p>
                        </div>
                    ))}
                </div>
            </FadeInSection>
        </section>
    );
};

export default SpokenLanguagesSection;
